import { useState, useRef, useEffect } from "react";
import {
FaMusic,
FaPlay,
FaPause,
FaHeadphones,
} from "react-icons/fa";

interface Props {
    mobile?: boolean;
}

interface Song {
    title: string;
    artist: string;
    src: string;
}

const playlist: Song[] = [
    {
        title: "Track 00",
        artist: "-",
        src: "/song1.mp3", 
    },
    {
        title: "Track 01",
        artist: "-",
        src: "/song2.mp3",
    },
    {
        title: "Track 02",
        artist: "-",
        src: "/song3.mp3",
    },
    {
        title: "Track 03",
        artist: "-",
        src: "/song4.mp3",
    },
];


export default function KaipediaMusicSidebar({
    mobile = false,
}: Props) {
    const [current, setCurrent] = useState<number>(0);
    const [isPlaying, setIsPlaying] = useState<boolean>(false);

    const audioRef = useRef<HTMLAudioElement>(null); 

    useEffect(() => {
        if (audioRef.current) {
        audioRef.current.load(); 
        if (isPlaying) {
            audioRef.current.play().catch((err) => console.log("Playback interrupted:", err));
        }
        }
    }, [current]);

    useEffect(() => {
        if (audioRef.current) {
        if (isPlaying) {
            audioRef.current.play().catch((err) => console.log("Playback interrupted:", err));
        } else {
            audioRef.current.pause();
        }
        }
    }, [isPlaying]);

    const togglePlay = () => {
        setIsPlaying(!isPlaying);
    };

    const handleSelectSong = (index: number) => {
        if (current === index) {
        togglePlay();
        } else {
        setCurrent(index);
        setIsPlaying(true);
        }
    };

    const handleSongEnded = () => {
        if (current < playlist.length - 1) {
        setCurrent(current + 1);
        } else {
        setCurrent(0); 
        }
    };

    return (
        <aside
            className={
                mobile
                    ? "w-full"
                    : "hidden lg:flex fixed left-0 inset-y-0 w-72 border-r border-cyan-500/10 p-8 flex-col bg-[#050b18] z-20"
            }
        >
            <audio 
                ref={audioRef} 
                src={playlist[current].src} 
                onEnded={handleSongEnded}
            />
            <div className="mt-10">
                <h1 className="text-3xl font-black text-white italic tracking-tighter uppercase">
                    KAI
                    <span className="text-cyan-400 drop-shadow-[0_0_8px_rgba(34,211,238,0.5)]">
                        PEDIA
                    </span>
                </h1>
                <div className="h-[2px] w-12 bg-cyan-500 mt-1"></div>
                <p className="mt-3 text-[10px] uppercase tracking-widest text-slate-500">
                    K-Music
                </p>
            </div>

            <div className="mt-8 bg-[#0a1628] rounded-3xl overflow-hidden border border-cyan-500/20">
                <div className="relative">
                    <img
                        src="/About_SystemK13.png"
                        alt="cover"
                        className="w-full h-52 object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050b18] via-transparent to-transparent" />

                    <div className="absolute top-4 right-4">
                        <button
                            onClick={togglePlay}
                            className="w-10 h-10 rounded-full bg-cyan-500 text-[#050b18] flex items-center justify-center hover:scale-105 active:scale-95 transition-all"
                        >
                            {isPlaying ? <FaPause size={12} /> : <FaPlay size={12} className="ml-0.5" />}
                        </button>
                    </div>

                    <div className="absolute bottom-4 left-4 right-4">
                        <p className="text-[10px] text-cyan-400 uppercase font-bold tracking-widest">
                            NOW PLAYING
                        </p>
                        <h3 className="text-white font-black text-lg leading-tight truncate">
                            {playlist[current].title}
                        </h3>
                    </div>
                </div>
            </div>

            <div className="mt-8 flex-1 overflow-y-auto no-scrollbar">
                <div className="flex items-center gap-2 mb-4">
                    <FaHeadphones className="text-cyan-400" />
                <h3 className="text-[10px] font-black tracking-[0.3em] uppercase text-cyan-400">
                    Playlist
                </h3>
                </div>

                <div className="space-y-2">
                    {playlist.map((song, index) => (
                        <button
                            key={index}
                            onClick={() => handleSelectSong(index)}
                            className={`w-full text-left p-3 rounded-xl border transition-all ${
                                current === index
                                ? "bg-cyan-500/10 border-cyan-500/40"
                                : "bg-[#0a1628]/40 border-cyan-500/10 hover:border-cyan-500/30 hover:bg-[#0d1d35]"
                            }`}
                        >
                        <div className="flex items-center gap-3">
                            <div
                                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                                    current === index
                                    ? "bg-cyan-500 text-[#050b18]"
                                    : "bg-slate-800 text-cyan-400"
                                }`}
                            >
                                {current === index && isPlaying ? (
                                    <FaPause size={9} />
                                ) : (
                                    <FaMusic size={10} />
                                )}
                            </div>

                            <div className="min-w-0 flex-1">
                                <p className="text-xs font-bold text-white truncate">
                                    {song.title}
                                </p>
                                <p className="text-[10px] text-slate-500 uppercase">
                                    {song.artist}
                                </p>
                            </div>
                        </div>
                        </button>
                    ))}
                </div>
            </div>
        </aside>
    );
}